/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Kabeer Haseja",
  title: "Hi there, I'm Kabeer 👋",
  subTitle: emoji(
    "I'm a Senior React Native Engineer with 5+ years of experience shipping production mobile apps to the App Store and Play Store. Today I build two apps in parallel: BigBaat, a short-video social platform with live streaming and creator payouts, and Circus Daily, a sports fan-engagement app for European audiences at Low6.\n\nMy work sits where product meets deep technical craft — hybrid React Native architectures with native Kotlin and Swift modules, real-time systems over Socket.IO and SignalR, secure networking with SSL pinning and signed requests, and release pipelines that get builds into reviewers' hands reliably.\n\nI care about apps that stay fast as they grow, codebases the next engineer can actually work in, and shipping on schedule."
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1eZ70lh4aQ8sfYto2T4n9LJRujYxJX6Ux?usp=sharing", // Leave empty to hide
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Kabeer-Haseja",
  linkedin: "https://www.linkedin.com/in/kabeer-haseja",
  gmail: "haseja45@gmail.com",
  medium: "https://medium.com/@haseja45",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle:
    "I build cross-platform mobile apps that hold up in production — fast, secure, and maintainable long after launch day 🚀",
  skills: [
    emoji(
      "⚡ Architect React Native apps in TypeScript with Redux Toolkit and React Query, structured so features can be added without the codebase fighting back"
    ),
    emoji(
      "⚡ Bridge into native Kotlin and Swift for the things JavaScript can't do well — video feeds, live broadcasting, and camera pipelines"
    ),
    emoji(
      "⚡ Build real-time experiences over Socket.IO and SignalR: live chat, live scores, streaming interactions, and instant state sync"
    ),
    emoji(
      "⚡ Harden apps for release with SSL pinning, Keychain-backed auth, signed API requests, and Crashlytics and Sentry monitoring"
    ),
    emoji(
      "⚡ Own the release pipeline end to end — Fastlane, GitHub Actions, code signing, multi-flavour builds, and App Store and Play Store submissions"
    ),
    emoji(
      "⚡ Ship fully localised apps, including right-to-left Arabic layouts and five-language European releases"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "React Native",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fas fa-file-code"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fas fa-atom"
    },
    {
      skillName: "Redux Toolkit",
      fontAwesomeClassname: "fas fa-bolt"
    },
    {
      skillName: "React Query",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "Swift / iOS",
      fontAwesomeClassname: "fas fa-tablet-alt"
    },
    {
      skillName: "Kotlin / Android",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "WebSockets",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "CI/CD",
      fontAwesomeClassname: "fas fa-infinity"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fas fa-code-branch"
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "fas fa-database"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sukkur IBA University",
      logo: require("./assets/images/iba.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "August 2017 - July 2021",
      desc: "Graduated with distinction and was awarded the Sindh Endowment Scholarship for academic excellence.",
      descBullets: [
        "Led hackathon and competitive programming teams, building working prototypes under tight deadlines",
        "Focused coursework in software engineering, algorithms, and mobile application development",
        "Active in the campus tech community, organising and attending industry workshops"
      ]
    },
    {
      schoolName: "Higher Secondary School",
      // logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Intermediate — Pre-Engineering",
      duration: "September 2013 - April 2016",
      desc: "Built the mathematics and computing foundation that led me into software engineering.",
      descBullets: [
        "First exposure to programming and problem solving, which set the direction for my degree",
        "Collaborated on group projects that developed early teamwork and communication habits"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "React Native & TypeScript", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Mobile Architecture & State Management",
      progressPercentage: "92%"
    },
    {
      Stack: "Native Modules (Swift / Kotlin)",
      progressPercentage: "80%"
    },
    {
      Stack: "Release Engineering & CI/CD",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior React Native Engineer",
      company: "Low6",
      companylogo: require("./assets/images/circusDaily.png"), // Make sure you add this logo to your assets
      date: "Feb 2026 – Present",
      location: "United Kingdom — Remote",
      metrics: [
        {value: "5", label: "Locales Shipped"},
        {value: "600+", label: "Commits Merged"},
        {value: "iOS + Android", label: "Platforms Owned"}
      ],
      desc: "Leading mobile architecture for Circus Daily, a sports fan-engagement app serving French, Dutch and wider European audiences on iOS and Android.",
      descBullets: [
        "Built the app's real-time layer on Microsoft SignalR with MessagePack, pushing live scores, fixture updates and CMS content to users without polling",
        "Designed the network layer end to end — Axios instance, token refresh, interceptor-based error handling and retry logic — for predictable behaviour on unreliable mobile connections",
        "Standardised state management on React Query for server data and Zustand for UI state, cutting redundant re-renders and memory pressure on long-lived screens",
        "Implemented secure authentication with JWT, refresh tokens and React Native Keychain, keeping credentials out of JavaScript memory",
        "Shipped full internationalisation across five locales (EN, FR, NL, ES, DE) with i18next, plus light and dark themes",
        "Own the iOS release pipeline: Fastlane, Cloud Managed Apple Distribution signing, provisioning profiles, IPA export and TestFlight distribution"
      ]
    },
    {
      role: "Senior React Native Engineer",
      company: "Walee Technologies",
      companylogo: require("./assets/images/bigbaat.png"),
      date: "Feb 2026 – Present",
      location: "Pakistan — Remote",
      metrics: [
        {value: "68K", label: "Lines of TypeScript"},
        {value: "53", label: "App Screens"},
        {value: "220+", label: "Commits Merged"}
      ],
      desc: "Building BigBaat, a short-video social platform with live streaming, in-app chat and creator monetisation — a hybrid React Native and native codebase spanning roughly 68,000 lines of TypeScript across 53 screens.",
      descBullets: [
        "Deliver features across the full stack of the app: React Native screens in TypeScript alongside native Kotlin and Swift modules for the video feed, live broadcast and camera",
        "Built the creator wallet and monetisation flows — coin top-ups via Easypaisa and JazzCash, withdrawals, gift transactions and transaction history",
        "Implemented real-time chat and live-stream interactions over Socket.IO, including comments, reactions, polls and live gifting",
        "Hardened the app for production with SSL pinning, HMAC-signed API requests, Keychain-backed device identity and root and emulator detection",
        "Tuned feed performance with FlashList, FastImage caching and MMKV-backed persistence to keep scrolling smooth on low-end Android devices",
        "Maintain separate staging and production build flavours on both platforms, with Firebase Analytics, Crashlytics, Remote Config and AppsFlyer attribution wired through each"
      ]
    },
    {
      role: "Senior React Native Engineer (Contract)",
      company: "Barmajja",
      companylogo: require("./assets/images/connect_Icon.png"),
      date: "Jan 2025 – Feb 2026",
      location: "United Arab Emirates — Remote",
      metrics: [
        {value: "25%", label: "Sales Uplift"},
        {value: "25%", label: "Engagement Lift"},
        {value: "100+", label: "Partner Retailers"}
      ],
      desc: "Delivered Connect, a location-aware loyalty and rewards app connecting shoppers with offers from partner retailers across the UAE.",
      descBullets: [
        "Built QR-based offer redemption end to end, which drove a 25% increase in user-attributed sales in Q1 2025",
        "Integrated GPS and the Google Maps API to surface nearby discounts based on the user's live location",
        "Implemented Firebase push notifications for timely deal alerts, lifting user engagement by 25%",
        "Worked directly with the marketing and business teams to align the roadmap with retention targets"
      ]
    },
    {
      role: "Senior React Native Engineer",
      company: "Dubizzle",
      companylogo: require("./assets/images/dubizzle.png"),
      date: "Jan 2022 – Jan 2026",
      location: "United Arab Emirates — Remote",
      metrics: [
        {value: "35%", label: "Performance Gain"},
        {value: "40%", label: "Fewer Crashes"},
        {value: "5", label: "Markets Localised"}
      ],
      desc: "Spent four years building mobile products across Dubizzle's real estate and vehicle marketplaces, serving users in Pakistan, the UAE, Saudi Arabia, Qatar and Egypt.",
      descBullets: [
        "Migrated legacy React Native codebases to TypeScript, the React Native CLI and functional components, delivering a 35% performance improvement and 20% faster load times",
        "Upgraded React Native from 0.64.2 to 0.75 across the app estate, resolving library incompatibilities and improving overall stability",
        "Integrated OneSignal, Google Maps, Firebase Crashlytics and location services for push notifications and location-aware features",
        "Built a geofencing system that triggers personalised offers within a 0.5-mile radius, raising redemption rates by 15%",
        "Delivered fully localised right-to-left Arabic releases with complete i18n support across five markets",
        "Contributed to stability work that cut crash rates by 40% and tightened the production release cycle"
      ]
    },
    {
      role: "React Native Developer",
      company: "Freelance",
      companylogo: require("./assets/images/upworkk.png"),
      date: "Feb 2020 – Aug 2021",
      location: "Remote — International Clients",
      metrics: [
        {value: "4+", label: "Apps Delivered"},
        {value: "30%", label: "Faster Releases"},
        {value: "4.9★", label: "Client Rating"}
      ],
      desc: "Delivered cross-platform mobile apps for international clients, owning each project from requirements through to store release.",
      descBullets: [
        "Built 4+ cross-platform apps with React Native and Redux over REST APIs, accelerating deployment cycles by 30% and resolving 80% of user-reported bugs",
        "Applied lazy loading and code splitting to cut load times by 25% and smooth out UI transitions",
        "Managed the full delivery lifecycle including code signing, builds and App Store and Play Store submissions",
        "Maintained 4.9+ star client ratings across engagements"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Featured Projects",
  subtitle:
    "PRODUCTION MOBILE APPS SHIPPED TO THE APP STORE AND PLAY STORE",
  projects: [
    {
      image: require("./assets/images/bigbaat.png"),
      projectName: "BigBaat — Short-Video Social Platform",
      company: "Walee Technologies",
      role: "Senior React Native Engineer · 2026 – Present",
      projectDesc:
        "A short-video social platform where creators publish, go live and earn. I work across a hybrid codebase — React Native in TypeScript over native Kotlin and Swift modules — covering the vertical video feed, live streaming with polls and gifting, Socket.IO chat, and a creator wallet with Easypaisa and JazzCash payouts. The app ships with SSL pinning, HMAC-signed requests and root detection, and runs separate staging and production flavours on both platforms.",
      techStack: [
        "React Native 0.83",
        "TypeScript",
        "Redux Toolkit",
        "React Query",
        "Socket.IO",
        "Kotlin",
        "Swift",
        "MMKV",
        "Firebase"
      ],
      footerLink: [
        {
          name: "Play Store",
          url: "https://play.google.com/store/apps/details?id=com.bigbaat"
        },
        {
          name: "App Store",
          url: "https://apps.apple.com/app/id6651854534"
        },
        {
          name: "Website",
          url: "https://bigbaat.app"
        }
      ]
    },
    {
      image: require("./assets/images/circusDaily.png"),
      projectName: "Circus Daily — Sports Fan Engagement App",
      company: "Low6",
      role: "Senior React Native Engineer · 2026 – Present",
      projectDesc:
        "A sports media and fan-engagement app for French, Dutch and wider European audiences, combining live scores, news, match analytics and fan voting. I lead the mobile architecture: real-time fixture and score updates over Microsoft SignalR with MessagePack, match detail screens covering lineups, head-to-head, standings and stats, favourites with push preferences, and an embedded Fan Zone. Localised across five languages and released to TestFlight through a Fastlane pipeline.",
      techStack: [
        "React Native 0.80",
        "TypeScript",
        "SignalR",
        "React Query",
        "Zustand",
        "Reanimated 4",
        "i18next",
        "Fastlane",
        "Sentry"
      ],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.circusdaily.com"
        }
      ]
    },
    {
      image: require("./assets/images/Dubizzle-CRM.png"),
      projectName: "Dubizzle CRM",
      company: "Dubizzle",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A CRM for Dubizzle's vehicle marketplace that lets sales agents manage thousands of listings from their phones. It pulled inspection, auction and seller operations into one workflow, automating data tracking and team hand-offs, and improved team efficiency by 40%.",
      techStack: ["React Native", "TypeScript", "Redux", "REST APIs"]
    },
    {
      image: require("./assets/images/Dubizzle-Auction.png"),
      projectName: "Dubizzle Auction",
      company: "Dubizzle",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A real-time vehicle auction platform built inside the Dubizzle app using React Native and WebSockets, with secure bidding, automated listing approvals and live status tracking. It lifted user engagement by 30%, tripled monthly car listings and opened a new revenue line for the business.",
      techStack: ["React Native", "WebSockets", "Redux", "Firebase"]
    },
    {
      image: require("./assets/images/Dubizzle-Inspection.png"),
      projectName: "Dubizzle Vehicle Inspection",
      company: "Dubizzle",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A field inspection app that standardised how Dubizzle evaluates vehicles. Inspectors complete 500+ detailed reports a month against 200+ checkpoints per car, which cut post-sale disputes by 40% and gave buyers a consistent, transparent condition report.",
      techStack: ["React Native", "Offline Sync", "Camera", "REST APIs"]
    },
    {
      image: require("./assets/images/jarvis_main_logo.png"),
      projectName: "Jarvis — Real Estate CRM",
      company: "Dubizzle",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A CRM serving 100K+ active users across Pakistan, the UAE, Saudi Arabia and Egypt, integrated with zameen.com, bayut.com and olx.com. Automated workflows and lead management improved task management efficiency by 40% and measurably raised sales team productivity.",
      techStack: ["React Native", "Redux Toolkit", "REST APIs", "Push Notifications"]
    },
    {
      image: require("./assets/images/olx.png"),
      projectName: "OLX Pakistan — Marketplace App",
      company: "Dubizzle Group",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "Integrated payment gateways and logistics management over REST APIs for secure end-to-end transactions, alongside React Native performance work across iOS and Android. Customer satisfaction scores rose 30% following the release.",
      techStack: ["React Native", "Payment Gateways", "REST APIs", "Redux"]
    },
    {
      image: require("./assets/images/olxSellerCenter.png"),
      projectName: "OLX Seller Center",
      company: "Dubizzle Group",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A merchant platform letting businesses list products, manage orders and track shipments in real time, with analytics and reporting that turned raw sales data into decisions sellers could act on.",
      techStack: ["React Native", "Redux", "Analytics", "REST APIs"]
    },
    {
      image: require("./assets/images/dubizzle_seller_center_icon.png"),
      projectName: "Dubizzle Seller Center",
      company: "Dubizzle",
      role: "Senior React Native Engineer · 2022 – 2026",
      projectDesc:
        "A product and order management system giving Dubizzle sellers listing management, order fulfilment workflows, performance dashboards and targeted push notifications to scale their operations.",
      techStack: ["React Native", "Redux Toolkit", "Firebase", "REST APIs"]
    },
    {
      image: require("./assets/images/connect_Icon.png"),
      projectName: "Connect — Loyalty & Rewards App",
      company: "Barmajja",
      role: "Senior React Native Engineer · 2025 – 2026",
      projectDesc:
        "A location-aware loyalty app partnered with 100+ retailers, pairing GPS-triggered promotions with a points-based rewards system and QR redemption. Engagement rose 35% and repeat transactions increased 25%.",
      techStack: ["React Native", "Google Maps", "Firebase", "QR / Camera"]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Highlights 🏆"),
  subtitle:
    "A few results I'm proud of from shipping mobile products at scale",

  achievementsCards: [],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Writing",
  subtitle:
    "Notes on React Native, mobile architecture and what I learn shipping apps",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@haseja45/react-native-2025-whats-new-and-why-it-matters-af354d7495ad",
      title: "Why React Native 2025: What's New and Why It Matters",
      description:
        "React Native continues to evolve at a rapid pace in 2025, pushing the boundaries of cross-platform mobile development. Whether you're maintaining a legacy app or building something fresh."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Speaking Engagements & Knowledge Sharing",
  subtitle: emoji(
    "PASSIONATE ABOUT SHARING KNOWLEDGE AND CONTRIBUTING TO THE DEVELOPER COMMUNITY 🎤"
  ),

  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast Appearances 🎙️"),
  subtitle: "SHARING INSIGHTS ON MOBILE DEVELOPMENT, TECHNOLOGY TRENDS, AND CAREER GROWTH",

  // Please Provide with Your Podcast embeded Link
  podcast: [],
  display: false // Set false to hide this section, defaults to false
};

const contactInfo = {
  title: emoji("Let's Talk ☎️"),
  subtitle:
    "I'm open to senior React Native roles, fully remote worldwide, and happy to relocate for the right team. If you're hiring or want to talk through a mobile project, get in touch — I reply to every message.",
  number: "+92-337-730-4400",
  email_address: "haseja45@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
